/**
 * Дверь телефона рядом с urlFor, не вместо.
 *
 * Не-Poly: тот же https стола. Poly: путь события+рынка, query купона на месте.
 */

import { canonBook, urlFor } from '../hosts';
import { webOnly } from './detect';
import { polyCouponPhone } from './couponPhone';

export type PhoneDoorOpts = {
  webOnly?: boolean;
};

export function urlForPhone(
  source: string,
  url: string | null | undefined,
  opts?: PhoneDoorOpts,
): string | null {
  const desk = urlFor(source, url);
  if (desk === null) return null;
  const skipApp = opts?.webOnly === true || webOnly();
  if (canonBook(source) === 'polymarket') return polyCouponPhone(desk, { webOnly: skipApp });
  return desk;
}
